import React, { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { IntlContext } from "context";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import ImageUpload from "components/File/ImageUpload";
import Label from "ui/Form/Element/Label";
import { TextView } from "ui/View";
import { SUBCATEGORY_TO_CATEGORY, SubCategory } from "types/subCategory";
import { fetchProfile } from "hooks/profile";
import { useParams } from "react-router";
import { Loader } from "ui/Loader";
import Seo from "components/Seo";

const Profile: React.FC = () => {
    const intl = useContext(IntlContext);
    const { id: userId } = useParams() as { id: string };
    const { data, isLoading } = useQuery({
        queryKey: ["profile-other-person", userId],
        queryFn: () => fetchProfile(userId),
        enabled: !!userId,
    });

    if (isLoading || !data) {
        return <Loader />;
    }
    const seoTitle = intl.formatMessage("profile.seo.title", {
        firstName: data.first_name ?? intl.formatMessage("provider.view.default_name"),
    });
    const provider = data.resources?.provider;
    const seoDescription = provider?.description?.slice(0, 160);
    const isProviderProfile = !!provider?.id;
    const providerServices = (provider?.services ?? []).filter(
        (service): service is string => typeof service === "string" && service.length > 0,
    );
    return (
        <div className="register">
            <Seo title={seoTitle} description={seoDescription} ogType="article" />
            <div className="container">
                <div className="grid--12 register__grid grid--has-gutter-3x">
                    <div className="register__container grid__col--5 grid__col--small-12">
                        <div className="flex flex--justify-content-center">
                            <ImageUpload id={data?.picture_id} withUpload={false} />
                        </div>
                        <div className="flex flex--align-items-center flex--direction-column margin-top--3">
                            <p>
                                {data?.first_name} {data?.last_name?.charAt(0)}.
                            </p>
                            {isProviderProfile && (
                                <p>
                                    {intl.formatMessage("profile.label.my_profile.nb_services", {
                                        nb_services: providerServices.length,
                                    })}
                                </p>
                            )}
                            {data?.address && (
                                <p>
                                    <Icon icon={{ prefix: "fas", iconName: "location-dot" }} /> {data.address}
                                </p>
                            )}
                        </div>

                        <div className="register__group-fields margin-top--5">
                            <div className="register__grid">
                                <div className="grid--1 grid--small-1 grid--has-gutter-3x register__grid">
                                    <TextView
                                        label={
                                            <div className="my_profile_description_label_container">
                                                <span className="margin-right--2">
                                                    {intl.formatMessage("profile.label.my_profile.description")}
                                                </span>
                                            </div>
                                        }
                                        value={provider?.description}
                                        inputClassname={
                                            provider?.description ? "my_profile_description" : ""
                                        }
                                    />
                                    <div className="my_profile_services margin-top--2">
                                        <Label>{intl.formatMessage("profile.label.my_profile.services")}</Label>
                                        {(provider?.services ?? []).map((service: string) => {
                                            let serviceSubCategory: SubCategory = service as unknown as SubCategory;
                                            return (
                                                <div
                                                    className="btn btn__outline--primary btn__outline--square  btn--default my_profile_services--items"
                                                    key={service}
                                                >
                                                    {intl.formatMessage(
                                                        "subcategory." +
                                                            SUBCATEGORY_TO_CATEGORY[
                                                                serviceSubCategory
                                                            ].toLocaleLowerCase() +
                                                            "." +
                                                            service.toLocaleLowerCase() +
                                                            ".label",
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="register__container grid__col--7 grid__col--small-12">Avis détaillés</div>
                </div>
            </div>
        </div>
    );
};

export default Profile;
